import { Link } from 'react-router-dom'
import { FaArrowRight } from 'react-icons/fa6'
import AnimatedSection from '../common/AnimatedSection'
import { whyChooseStats, whyChooseUs } from '../../data/siteData'
import { IconCheck } from '../icons/AboutWhyChooseIcons'
import StatsBar from '../home/StatsBar'

const aboutWhyCollage = '/assets/about-why-collage.png'

function AboutWhyChooseSection() {
  return (
    <AnimatedSection className="about-why-section">
      <div className="container corp-container">
        <div className="row g-4 g-lg-5 align-items-center about-why-main">
          <div className="col-lg-6">
            <div className="about-why-copy">
              {/* <span className="section-label section-label--gold about-why-label">Why Choose Us</span> */}
              <div className="about-vision-label">
                <span className="about-vision-label-line" aria-hidden="true" style={{ height: '3px', width: '32px' }} />
                <span>Why Choose Us</span>
              </div>
              <h2 className="about-why-title">
                Why Clients Choose <span>Torbit Metals</span>
              </h2>
              <p className="about-why-lead">
                We combine industry expertise, global network, and customer-focused approach to
                deliver unmatched value to our clients.
              </p>
              <ul className="about-why-list">
                {whyChooseUs.map((item) => (
                  <li key={item}>
                    <span className="about-why-check" aria-hidden="true">
                      <IconCheck />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
              <Link className="about-why-cta" to="/contact#inquiry-form">
                Get In Touch
                <FaArrowRight aria-hidden="true" />
              </Link>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="about-why-visual">
              <span className="about-why-dots" aria-hidden="true" />
              <img
                src={aboutWhyCollage}
                alt="Metal industry, global logistics, warehousing and business partnership"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        {/* <StatsBar items={whyChooseStats} className="about-why-stats-bar" /> */}
      </div>
    </AnimatedSection>
  )
}

export default AboutWhyChooseSection
